import React from 'react';
import PropTypes from 'prop-types';
import { ValidatorComponent } from 'react-material-ui-form-validator';
import { withStyles, Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import CheckedBoxIcon from '../assets/checked-box.svg';
import UnCheckedBoxIcon from '../assets/unchecked-box.svg';

const styles = theme => ({
	wrapper: {
		marginTop: 2,
		marginBottom: 2
	},

	topHelperText: {
		marginBottom: theme.spacing(1)
	},

	bottomHelperText: {
		fontSize: "0.985rem",
		marginBottom: theme.spacing(3)
	},

	checkboxMargin: {
		marginRight: 3
	},

	checkboxError: {
		color: '#f44336'
	},

	checkboxErrorMsg: {
		color: '#f44336',
		display: 'block',
		marginTop: 0
	}
});

class LabeledCheckbox extends ValidatorComponent {
	render() {
		let {isValid} = this.state,
			{classes, disabled, onChange, checked, checkboxColor, topHelperText, bottomHelperText,
				useIdForValue, errorMessages, validators, validatorListener, requiredError,
				value, labelClasses, checkboxClassName, ...rest} = this.props;

		// in case it comes in as a string
		if (typeof checked === "string") {
			checked = checked === "true";
		}

		return (
			<React.Fragment>
				{topHelperText ? (
					<FormHelperText
						className={classes.topHelperText}
						disabled={disabled}>{topHelperText}</FormHelperText>
				) : null}
				<FormControlLabel
					{...rest}
					disabled={disabled}
					checked={!!checked}
					className={classes.wrapper}
					classes={labelClasses}
					control={
						<Checkbox
							ref={(r) => { this.input = r; }}
							color={checkboxColor || 'secondary'}
							className={`${classes.checkboxMargin} ${checkboxClassName}${isValid ? "" : " "+classes.checkboxError}`}
							onChange={(e) => {
								if (useIdForValue) {
									e.target.value = e.target.id;
									e.target.ignoreCheckbox = useIdForValue;
								} else {
									e.target.value = e.target.checked;
								}

								onChange(e);
							}}
							inputProps={{
								id: rest.id,
								'aria-label': rest.label || '',
								'aria-describedby': `${rest.id}-helper-text`
							}} 
							icon={<img src={UnCheckedBoxIcon} alt="unchecked icon" />}
							checkedIcon={<img src={CheckedBoxIcon} alt="checked icon" />}
						/>
					} />
				{!isValid ? (
					<FormHelperText className={classes.checkboxErrorMsg}>
						{this.getErrorMessage()}
					</FormHelperText>
				) : null}
				{bottomHelperText ? (
					<FormHelperText
						id={`${rest.id}-helper-text`}
						className={classes.bottomHelperText}
						disabled={disabled}>{bottomHelperText}</FormHelperText>
				) : null}
			</React.Fragment>
		);
	}
}

LabeledCheckbox.propTypes = {
	classes: PropTypes.object.isRequired,
	checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
	checkboxColor: PropTypes.string,
	helperText: PropTypes.string,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	useIdForValue: PropTypes.bool,
	labelClasses: PropTypes.object,
	checkboxClassName: PropTypes.string
};

export default withStyles(styles)(LabeledCheckbox);
